export const GET_All_SMS_BY_NUMBERS= 'GET_All_SMS_BY_NUMBERS';
export const REFRESH_SMS_BY_NUMBERS= 'REFRESH_SMS_BY_NUMBERS';
export const LOAD_SMS_LOADING= 'LOAD_SMS_LOADING';
export const LOAD_SMS_ERROR= 'LOAD_SMS_ERROR';
